import { getLoginRequests, msalConfig } from "./authConfig";

export default function Debug() {
    return (<>
        <section>
            <h1>NewDay Project Stratus Debug Page</h1>
            <h3>MsalConfig</h3>
            <p>
                {JSON.stringify(msalConfig)}
            </p>
            <h3>Scopes</h3>
            <p>
                {JSON.stringify(getLoginRequests())}
            </p>
            <h3>Node Environment</h3>
            <p>
                {JSON.stringify(process.env.NODE_ENV)}
            </p>
        </section>
    </>);

}